import { ReactNode } from 'react';

import { Alert } from 'components/Display/Alert/Alert';
import { Severity } from 'components/Display/Alert/types';

type ContentBannerProps = {
  children: ReactNode;
  severity?: Severity;
  withWrapper?: boolean;
};

export const ContentBanner = ({ children, severity = 'error', withWrapper = true }: ContentBannerProps) => {
  return (
    <Alert withoutIcon severity={severity} fullWidth>
      {withWrapper ? <div className="flex w-full items-center justify-between">{children}</div> : children}
    </Alert>
  );
};
